import { type GetTeamsQueryParams } from '@gonfalon/openapi/operations/getTeams';

import { createQueryHook } from '../internal/createQueryHook';
import { teams } from '../queries/teams';

/**
 * @deprecated Use `teams.list()` with `useQuery` directly.
 */
export const useTeams = createQueryHook(({ params }: { params?: GetTeamsQueryParams }) => teams.list({ params }));
